module.exports = __webpack_public_path__ + "static/Wolters_Kluwer_Logo-858e63a5e4b50916092f000c7cc47023.svg";